import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AccountController } from "../../core/config/controllers/AccountController";

export default function Recover(props) {
  const [email, setEmail] = useState(null);

  function recover() {
    if (email === null || email === "") {
      toast.error("Escreva o seu email para recuperar a senha");
      return;
    }
    AccountController.Recover(email);
  }

  function goAuth() {
    window.location = "#/";
  }

  return (
    <div id="page-container">
      <main id="main-container">
        <div
          className="bg-image"
          style={{
            backgroundImage: "url('assets/media/photos/silvia.png')",
          }}
        >
          <div className="row no-gutters bg-primary-op">
            <div className="hero-static col-md-6 d-flex align-items-center bg-white">
              <div className="p-3 w-100">
                <div className="mb-3 text-center">
                  <a
                    className="link-fx font-w700 font-size-h1"
                    href="index.html"
                  >
                    <img src={"assets/media/logo.png"} style={{ maxWidth: "150px" }} />
                  </a>
                </div>
                <p className="text-center text-uppercase font-w700 font-size-sm text-muted">
                  Redefinir a senha
                </p>

                <div className="row no-gutters justify-content-center">
                  <div className="col-sm-8 col-xl-6">
                    <div className="js-validation-signin">
                      <div className="py-3">
                        <div className="form-group">
                          <span>E-mail</span>
                          <input
                            type="email"
                            className="form-control form-control-lg form-control-alt"
                            id="email"
                            name="email"
                            onChange={(evt) => setEmail(evt.target.value)}
                            placeholder="E-mail"
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <button
                          onClick={() => recover()}
                          className="btn btn-block btn-hero-lg btn-hero-warning text-dark"
                        >
                          <i className="fa fa-fw fa-arrow-right mr-1" />{" "}
                          Redefinir
                        </button>
                        <p className="mt-3 mb-0 text-center">
                          <a
                            className="btn btn-sm btn-light d-block d-lg-inline-block mb-1"
                            onClick={() => goAuth()}
                          >
                            <i className="fa fa-arrow-left text-muted mr-1" />{" "}
                            Voltar para login
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="hero-static col-md-6 d-none d-md-flex align-items-md-center justify-content-md-center text-md-center bg-image"
              style={{
                backgroundImage: "url('assets/media/photos/silvia.png')",
              }}
            >
              <div className="p-3">
                <p className="display-4 font-w700 text-white mb-3">
                  Recuperar a senha
                </p>
                <p className="font-size-lg font-w600 text-white-75 mb-0">
                  Rastro+ &copy;{" "}
                  <span className="js-year-copy">
                    {new Date().getFullYear()}
                    -Desenvolvido pela{" "}
                    <a
                      className="text-white"
                      href="https://navigate.one"
                      target="_blank"
                    >
                      Navigate
                    </a>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ToastContainer className="toastr" />
    </div>
  );
}
